<template>
    <div class="row ml-xl-4 m-0">
        <div class="col-12">
            <h3>Sanciones <Button @click="$modal.show('addSancion');" icon="fas fa-plus">Añadir</Button></h3>
            <AddSancion :abonado="abonado" v-on:close="cerrarModal"/>
        </div>
        <div class="col-12">
            <table v-if="sanciones.length > 0" class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th>Fecha de inicio</th>
                        <th>Fecha de fin</th>
                        <th class="text-center">Acceso bloqueado</th>
                        <th>Motivo</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(sancion, index) in sanciones">
                        <tr :key="index">
                            <td>{{ sancion.fecha_inicio }}</td>
                            <td>{{ sancion.fecha_fin }}</td>
                            <td class="text-center">
                                <CheckOrCross :condition="sancion.bloquear_acceso"/>
                            </td>
                            <td v-html="sancion.motivo">
                            </td>
                            <td>
                                <Button @click="$modal.show('borrar-sancion-' + sancion.id)">Borrar</Button>
                            </td>
                            <BorrarSancion :abonado="abonado" :sancion="sancion" @close="cerrarModal"/>
                        </tr>
                    </template>
                </tbody>
            </table>
            <p v-else>
                Este socio no tiene ninguna sanción.
            </p>
        </div>
    </div>
</template>

<script>
    import BorrarSancion from '@/views/backend/abonados/modals/BorrarSancion';
    import AddSancion from '@/views/backend/abonados/modals/AddSancion';
    import CheckOrCross from "@/components/backend/components/CheckOrCross";

    export default {
        props: {
            sanciones: Array,
            abonado: Object
        },
        methods: {
            cerrarModal(modal, actualizar) {
                this.$modal.hide(modal);
                if(actualizar) {
                    this.$emit('actualizar');
                }
            },
        },
        components: {
            BorrarSancion, AddSancion, CheckOrCross
        }
    }
</script>